export const userType = {
    'sales': 1,
    'support': 2,
    'academic': 3
}

